// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ck-password-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}

.center {
  display: flex;
  align-items: center;   /* vertical */
  justify-content: center; /* horizontal */
}


.ck-forgot {
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  color: #f59255;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  text-decoration: none;
}

.ck-forgot:hover {
  opacity: 0.85;
}
`, "",{"version":3,"sources":["webpack://./src/loginModal.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB,IAAI,aAAa;EACpC,uBAAuB,EAAE,eAAe;AAC1C;;;AAGA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf","sourcesContent":[".ck-password-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 6px;\n}\n\n.center {\n  display: flex;\n  align-items: center;   /* vertical */\n  justify-content: center; /* horizontal */\n}\n\n\n.ck-forgot {\n  background: none;\n  border: none;\n  padding: 0;\n  margin: 0;\n  color: #f59255;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.ck-forgot:hover {\n  opacity: 0.85;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
